import React, { Component } from 'react';
import ImgDI from '../Images/Collage.jpg';



export class Conferencia extends Component {
    constructor(props) {
        super(props);
        this.state = {
            qs: window.location.search,
            Evento: true,
            Nombre: "",
            Apellidos: "",
            Email: "",
            Errores : ""

        };

        this.navegarRegistro = this.navegarRegistro.bind(this);
        this.disponible = this.disponible.bind(this);
        this.validar = this.validar.bind(this);
        
    }

    componentDidMount() {
        this.disponible();
    }

    validar() {
        var Errs = [];
        if (this.state.Nombre == "") {
            Errs.push("Por favor proporcione su nombre");
        }
        if (this.state.Apellidos == "") {
            Errs.push("Por favor proporcione su apellido");
        }
        if (this.state.Email == "") {
            Errs.push("Por favor proporcione su email")
        } else {
            var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

            if (!this.state.Email.match(validRegex)) {
                Errs.push("Su email es inválido");
            }
        }
        if (Errs.length == 0) {
            this.setState({ Errores: "" });
            //this.disponible();
            document.getElementById("Forma").submit();
        } else {
            var ErrFinal = "";
            for (var i = 0; i < Errs.length; i++) {
                if (ErrFinal == "") {
                    ErrFinal = Errs[i];
                } else {
                    ErrFinal = ErrFinal + ", " + Errs[i];
                }
            }
            this.setState({ Errores: ErrFinal });
        }
    }
    navegarRegistro() {
        window.open("https://us22.list-manage.com/survey?u=418c31e87aceaf5bb5b2e9dbc&id=1beca88493&attribution=false", "_blank");
    }

    disponible() {

        var principal = this;
        //try {
        //    const response =  fetch("https://exchangeovh.icyteg.edu.mx/universum/api/webinar");
        //    if (response.status == 200) {
        //        principal.setState({ Evento: true });
        //    } else if (response.status == 202) {
        //        principal.setState({ Evento: false });

        //    }

        //} catch(error) {
        //    console.log(error);
        //}


        var xhr = new XMLHttpRequest();

        //xhr.open("GET", "https://www.google.com.mx", true);
        xhr.open("get", "api/Web/VerificarWebinar/" + (window.location.search == "" ? "x" : window.location.search).replace("?email=", ""), true);


        //xhr.onreadystatechange =  function () {
        //    if (xhr.readyState == 200) {
        //        principal.setState({ Evento: true });
        //    } else if (xhr.readyState == 202) {
        //        principal.setState({ Evento: false })
        //    };
        //    var x = 1;
        //};

        //});
        xhr.onload = function () {
            if (xhr.status == 200) {
                let datos = JSON.parse(xhr.responseText);
                if (datos.abierto == "true") {
                    principal.setState({ Evento: true, Nombre: datos.NombreCompleto, Email: datos.email });

                } else {
                    principal.setState({ Evento: false });

                }

            }

            //if (xhr.status == 200 && xhr.responseText == "true") {
            //    principal.setState({ Evento: true });
            //} else if (xhr.status == 200 && xhr.responseText == "false") {
            //    principal.setState({ Evento: false });

            //}

        };
        xhr.onerror = function (event) {
            

            alert('Error al cargar los datos');
        }


        xhr.send();
    }


    render() {
        return (
            <div>
            <br/>
                <br />
                <center>
                    <div style={{ display: "inline-block", paddingTop:"80px",  paddingBottom:"50px", zIndex: "2", backgroundColor: "white", width: "30%", minWidth: "380px"}}>
                        <center>
                            <strong>
                                                        <h2>Conferencia</h2>
                                <h2>Experiencias educativas: alumnos con discapacidad intelectual</h2>
                            </strong>
                            <p>7 de diciembre de 2024, 9:00 am</p>
                            <p ><em>
                                Dra. ALEJANDRA FABIOLA RODRIGUEZ SAYAGO
                                </em>
                            </p>
                            {
                                (this.state.Evento == true) ?
                                    <center>
                                        <strong>
                                            <br />

                                            <p style={{ lineHeight: "1" }}>Por favor proporciona tus datos 
                                            </p>
                                            <p style={{ lineHeight: "1" }}>para ingresar a la conferencia
                                            </p>
                                        </strong>
                                            <br/>
                                        <form action="https://exchange2019.icyteg.edu.mx/Universum/api/webinar" method="POST" id="Forma">
                                            <table>
                                                <tr>
                                                    <td>Nombre</td>
                                                    <td><input type="text" name="Nombre" value={this.state.Nombre} onChange={(e) => { this.setState({ Nombre: e.target.value }) }} /></td>
                                                </tr>
                                                <tr style={{ margin: "5px" }}>
                                                    <td >Apellidos</td>
                                                    <td><input type="text" name="Apellidos" value={this.state.Apellidos} onChange={(e) => { this.setState({ Apellidos: e.target.value }) } } /></td>
                                                </tr>
                                                <tr>
                                                    <td>Email</td>
                                                    <td><input type="text" name="Email" value={this.state.Email} onChange={(e) => { this.setState({ Email: e.target.value }) }} /></td>
                                                </tr>
                                            </table>
                                            <br />
                                            <div style={{ backgroundColor: "cadetblue", color: "white", width: "350px", padding: "10px", margin: "20px", cursor: "pointer" }} onClick={this.validar}>
                                                <center style={{ fontWeight: "bold", fontSize: "16pt" }}>
                                                    Ingresar
                                                </center>
                                            </div>
                                            <p style={{ color: "red", fontWeight: "bold" }}>{this.state.Errores}</p>
                                    </form>
                                </center>
                                :
                                <div>
                                    <div style={{ backgroundColor: "cadetblue", padding: "20px", margin: "10px",  color: "white", opacity: "1", cursor: "pointer" }} onClick={this.navegarRegistro}>
                                        Registrarse
                                    </div>
                                    {/*<div style={{*/}
                                    {/*    backgroundColor: "cadetblue", padding: "20px", margin: "10px", display: "inline-block", color: "white", opacity: ".7", cursor: "pointer" }}>*/}
                                    {/*    Ingresar*/}
                                    {/*</div>*/}
                                    <p>
                                    <strong>El día de la conferencia se habilitará esta página para usuarios registrados.</strong>
                                    </p>
                                </div>

                            }
                        </center>
                    </div>

                    <div style={{ display: "inline-block", width: "65%" }}>
                        <img src={ImgDI} style={{ width: "100%" }} alt="Imagen conferencia"/>
                    </div>
                </center>

            </div>
        )
    }
}
export default Conferencia;


// WEBPACK FOOTER //
// ./src/components/Conferencia.js